import React from 'react';
import { OrderDashboardModel } from '../../models/dashboard/order-dashboard-model';

const currency = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const amountText = (value?: number) =>
  value !== undefined && Number.isFinite(value) ? currency.format(value) : '—';

const percentageText = (value?: number) =>
  value !== undefined && Number.isFinite(value) ? `${value.toFixed(1)}%` : '—';

const OpenOrderPaymentBreakdown: React.FC<{ data: OrderDashboardModel }> = ({ data }) => (
  <dl className="ord-open-payments" aria-label="Open orders payment breakdown">
    <div className="ord-open-payment-row ord-open-payment-pending">
      <dt>Pending</dt>
      <dd>
        <span className="ord-open-payment-amount">{amountText(data.openOrdersPendingValue)}</span>
        <span className="ord-open-payment-percentage">({percentageText(data.openOrdersPendingPercentage)})</span>
      </dd>
    </div>
    <div className="ord-open-payment-row ord-open-payment-success">
      <dt>Success</dt>
      <dd>
        <span className="ord-open-payment-amount">{amountText(data.openOrdersSuccessValue)}</span>
        <span className="ord-open-payment-percentage">({percentageText(data.openOrdersSuccessPercentage)})</span>
      </dd>
    </div>
  </dl>
);

export default OpenOrderPaymentBreakdown;
